<template>
  <div>
    <p class="d-flex justify-center font-weight-bold mt-4 red--text">
      {{ $t("message.failed.title", { type: $t("message.job.job_type_" + command_type) } ) }}
    </p>
    <v-icon color="red" class="d-flex justify-center" size="60">mdi-alert-circle</v-icon>
    <div class="mt-8 mb-1 mx-1">
      <v-toolbar>
        <v-toolbar-title>
          {{ $t("message.failed.table_failed_title") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table
        :headers="failed_headers"
        :items="uploading_files.filter(v => !v.fid)"
        hide-default-footer
        class="elevation-1 mt-1"
        :class="$vuetify.breakpoint.xs ? '' : 'failed_table'"
        >
        <template v-slot:item.file_name="{ item }">
          <template v-if="item.file_name.length <= 40">
            {{ item.file_name }}
          </template>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ item.file_name.substr(0, 40) }}...
                </span>
              </template>
              <span>{{ item.file_name }}</span>
            </v-tooltip>
          </template>
        </template>
        <template v-slot:item.file_type="{ item }">
          <span>{{ $t("message.common." + item.file_type) }}</span>
        </template>
        <template v-slot:item.error="{ item }">
          <span>{{ $t("error." + get_eid(item.eid), replace_param(item.eid, item.param)) }}</span>
        </template>
      </v-data-table>
    </div>
    <div class="mt-8 mb-1 mx-1" v-if="uploading_files.filter(v => v.fid).length > 0 && show_table_type.indexOf(command_type) !== -1">
      <v-toolbar
        :height="auto"
        :extension-height="auto"
      >
        <v-toolbar-title class="pt-2">
          {{ $t("message.failed.table_success_title") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <p class="mx-4 caption text" slot="extension">
          {{ $t("message.failed.success_info", { navigation: $t("message.navigation." + change_navigation_parm(command_type)), uploaded: $t("message.common.uploaded_" + change_uploaded_parm(command_type)), type: $t("message.job.job_type_" + command_type) } ) }}
        </p>
      </v-toolbar>
      <v-data-table
        :headers="success_headers"
        :items="uploading_files.filter(v => v.fid)" hide-default-footer
        class="elevation-1 mt-1"
        :class="$vuetify.breakpoint.xs ? '' : 'failed_table'"
      >
        <template v-slot:item.file_name="{ item }">
          <template v-if="item.file_name.length <= 40">
            {{ item.file_name }}
          </template>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ item.file_name.substr(0, 40) }}...
                </span>
              </template>
              <span>{{ item.file_name }}</span>
            </v-tooltip>
          </template>
        </template>
        <template v-slot:item.file_type="{ item }">
          <span>{{ $t("message.common." + item.file_type) }}</span>
        </template>
        <template v-slot:item.fid="{ item }">
          <v-list-item dense @click="$router.push('/file/' + item.fid)" class="pl-0">
            <v-list-item-icon>
              <v-icon>
                mdi-link-variant
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{ item.fid }}
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-data-table>
    </div>
    <template v-if="show_link">
      <v-card flat class="d-flex justify-end pt-5">
        <p class="text-right ml-3">
          <v-btn x-large to="/">
            {{ $t("message.common.return_home") }}
          </v-btn>
        </p>
      </v-card>
    </template>
  </div>
</template>

<script>
  import { get_eid } from "../js/get_eid";
  export default {
    name: 'failed',
    mixins: [get_eid],
    props: {
      command_type: String,
      uploading_files: Array,
      show_link: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        module_id: "XX",
        show_table_type: [
          'translate',
          'estimate'
        ]
      }
    },
    methods: {
      change_navigation_parm(parm){
        if(parm === 'estimate'){
          return 'translate';
        }
        return parm;
      },
      change_uploaded_parm(parm){
        if(parm === 'train'){
          return 'corpus';
        }
        return 'file';
      },
      replace_param: function(eid, param){
        if(eid.startsWith("E2") && ["217", "218", "253", "254"].indexOf(eid.split(":")[0].slice(-3)) >= 0){
          return {
            layer: this.$i18n.t("message.limit_usage.layer_" + param.layer),
            resource: this.$i18n.t("message.limit_usage.resource_" + param.resource)
          }
        }else if(eid.startsWith("E1") && eid.split(":")[0].slice(-3) === "105"){
          return {
            source_lang: this.$i18n.t("message.common.lang_" + param.source_lang),
            target_lang: this.$i18n.t("message.common.lang_" + param.target_lang)
          }
        }else{
          return param;
        }
      }
    },
    created(){
      //console.log(this.uploading_files)
    },
    computed: {
      failed_headers:function() {
        return [
          {
            text: this.$i18n.t("message.common.file") + this.$i18n.t("message.common.any_name"),
            value: 'file_name',
            sortable: false
          },
          {
            text: this.$i18n.t("message.file.file_type"),
            value: 'file_type',
            sortable: false
          },
          {
            text: this.$i18n.t("message.failed.headers_error_text"),
            value: 'error',
            sortable: false
          }
        ]
      },
      success_headers:function() {
        return [
          {
            text: this.$i18n.t("message.common.file") + this.$i18n.t("message.common.any_name"),
            value: 'file_name',
            sortable: false
          },
          {
            text: this.$i18n.t("message.file.file_type"),
            value: 'file_type',
            sortable: false
          },
          {
            text: this.$i18n.t("message.common.fid"),
            value: 'fid',
            sortable: false
          }
        ]
      }
    }
  }
</script>
<style lang="scss">
.failed_table table{
  table-layout: fixed;
  & tr:hover:not(.v-table__expanded__content){
    background: #FFF !important;
  }
}
</style>
